import { useEffect, useState } from "react";
export default function Countdown({ to, className = "" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const i = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(i);
  }, []);
  const target = new Date(to).getTime();
  let diff = Math.max(0, target - now);
  const h = Math.floor(diff / 3.6e6); diff -= h * 3.6e6;
  const m = Math.floor(diff / 6e4); diff -= m * 6e4;
  const s = Math.floor(diff / 1000);
  const pad = (n) => n.toString().padStart(2, "0");
  return <span data-testid="countdown" className={`ticker-num ${className}`}>{pad(h)}:{pad(m)}:{pad(s)}</span>;
}
